// collections-slider.js — drag + autoplay 5s, opzionale navigazione con .ccs-prev/.ccs-next
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.ccs-section').forEach(function (root) {
      const vp = root.querySelector('.ccs-viewport');
      const track = root.querySelector('.ccs-track');
      if (!vp || !track || vp.swiper) return;

      // classi Swiper
      vp.classList.add('swiper');
      track.classList.add('swiper-wrapper');
      track.querySelectorAll(':scope > *').forEach(function (el) {
        el.classList.add('swiper-slide');
      });

      // controlli opzionali
      const prev = root.querySelector('.ccs-prev');
      const next = root.querySelector('.ccs-next');

      // parametri da data-*
      const spacing = Number(root.getAttribute('data-gap')) || 16;
      const peek = Number(root.getAttribute('data-peek')) || 40;

      const opts = {
        slidesPerView: 'auto',
        spaceBetween: spacing,
        slidesOffsetAfter: peek,
        grabCursor: true,
        speed: 400,
        loop: track.children.length > 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        observer: true,
        observeParents: true
      };

      if (prev && next) {
        opts.navigation = { prevEl: prev, nextEl: next };
      }

      const swiper = new Swiper(vp, opts);

      // fallback se il modulo Navigation non è disponibile
      if (prev && next && !(swiper.navigation && swiper.navigation.prevEl)) {
        prev.addEventListener('click', function () { swiper.slidePrev(); });
        next.addEventListener('click', function () { swiper.slideNext(); });
      }
    });
  });
})();
